var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 6.76751C9.91667 8.32545 8.61146 9.58731 7 9.58731C5.38854 9.58731 4.08333 8.32545 4.08333 6.76751C4.08333 5.20958 5.38854 3.94772 7 3.94772C8.61146 3.94772 9.91667 5.20958 9.91667 6.76751ZM7 8.45939C7.96615 8.45939 8.75 7.70157 8.75 6.76751C8.75 5.83346 7.96615 5.07563 7 5.07563C6.03385 5.07563 5.25 5.83346 5.25 6.76751C5.25 7.70157 6.03385 8.45939 7 8.45939ZM14 6.76751C14 9.84814 9.73438 15.3326 7.86406 17.5955C7.41562 18.1348 6.58437 18.1348 6.13594 17.5955C4.23281 15.3326 0 9.84814 0 6.76751C0 3.02987 3.13396 0 7 0C10.8646 0 14 3.02987 14 6.76751ZM7 1.12792C3.77708 1.12792 1.16667 3.65164 1.16667 6.76751C1.16667 7.31737 1.36464 8.07167 1.77042 9.0022C2.16818 9.91511 2.72708 10.9056 3.35927 11.896C4.60104 13.8452 6.07396 15.7098 7 16.8342C7.92604 15.7098 9.39896 13.8452 10.6422 11.896C11.2729 10.9056 11.8307 9.91511 12.2281 9.0022C12.6365 8.07167 12.8333 7.31737 12.8333 6.76751C12.8333 3.65164 10.2229 1.12792 7 1.12792Z",
    fill: "#55585C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location-2.85bb7202447dcda54e99319462f35a42.svg";
export { ForwardRef as ReactComponent };